import youtubeThumbnail from 'youtube-thumbnail';
export const data = [
    {
      id: 1,
      name: 'Mindful Breathing',
      type: 'meditation',
      category: 'stress',
      link: 'https://www.youtube.com/watch?v=inpok4MKVLM',
      description: 'Focus on your breath to calm the mind and reduce stress.',
    },
    {
      id: 2,
      name: 'Progressive Muscle Relaxation',
      type: 'meditation',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=ihO02wUzgkc',
      description: 'Relax your muscles to reduce anxiety and improve overall wellbeing.',
    },
    {
      id: 3,
      name: 'Guided Imagery',
      type: 'meditation',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=1vx8iUvfyCY',
      description: 'Visualize calming images to reduce symptoms of depression and anxiety.',
    },
    {
      id: 4,
      name: 'Yoga Nidra',
      type: 'meditation',
      category: 'stress',
      link: 'https://www.youtube.com/watch?v=zLJu3wQA1Ko',
      description: 'A guided meditation that promotes deep relaxation and stress relief.',
    },
    {
      id: 5,
      name: 'Box Breathing',
      type: 'meditation',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=6p_yaNFSYao',
      description: 'A breathing exercise that can help reduce anxiety and promote relaxation.',
    },
    {
      id: 6,
      name: 'Loving Kindness Meditation',
      type: 'meditation',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=sz7cpV7ERsM',
      description: 'A meditation practice that cultivates feelings of love and compassion towards oneself and others.',
    },
    {
      id: 7,
      name: 'Autogenic Training',
      type: 'meditation',
      category: 'stress',
      link: 'https://www.youtube.com/watch?v=P-_6GlnlOtM',
      description: 'A relaxation technique that involves visualizing warmth and heaviness in different parts of the body.',
    },
    {
      id: 8,
      name: 'Body Scan Meditation',
      type: 'meditation',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=6IATiVQ1u58',
      description: 'A meditation practice that involves scanning the body for sensations and promoting relaxation.',
    },
    {
      id: 9,
      name: 'Breath Counting',
      type: 'meditation',
      category: 'stress',
      link: 'https://www.youtube.com/watch?v=invL2KEt15Q',
      description: 'A simple breathing exercise that can help calm the mind and reduce stress.',
    },
    {
      id: 10,
      name: 'Visualization Meditation',
      type: 'meditation',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=UyyjU8fzEYU',
      description: 'A meditation practice that involves visualizing peaceful scenes to promote relaxation and reduce symptoms of depression.',
    },
    
    {
      id: 11,
      name: 'Gratitude Journaling',
      type: 'journaling',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=WI-picmRquE' ,
      description: 'A daily writing exercise that focuses on expressing gratitude and positive experiences.',
    },
    {
      id: 12,
      name: 'Nature Walk',
      type: 'exercise',
      category: 'stress',
      link: 'https://www.youtube.com/watch?v=PyFN_FYwqvc',
      description: 'A walk in nature can help reduce stress and improve overall wellbeing.',
      },
      {
      id: 13,
      name: 'Mindful Eating',
      type: 'mindfulness',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=gcIxWIDuKZQ',
      description: 'A practice that involves paying attention to the sensory experience of eating, helping to reduce anxiety and promote healthier habits.',
      },
      {
      id: 14,
      name: 'Visualization',
      type: 'meditation',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=E8k6LcYO_Vg',
      description: 'Visualize peaceful scenes and engage the senses to reduce symptoms of depression and anxiety.',
      },
      {
      id: 15,
      name: 'Progressive Muscle Relaxation for Sleep',
      type: 'relaxation',
      category: 'insomnia',
      link: 'https://www.youtube.com/watch?v=IZub-H2G4d4',
      description: 'Relax your muscles before bedtime to promote better sleep.',
      },
      {
      id: 16,
      name: 'Morning Pages',
      type: 'journaling',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=oZvrzjyi9S8',
      description: 'Write out stream-of-consciousness thoughts every morning to reduce anxiety and clear the mind for the day ahead.',
      },
      {
      id: 17,
      name: 'Breathing Exercise for Anxiety',
      type: 'meditation',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=8vkYJf8DOsc',
      description: 'A breathing exercise that can help reduce anxiety and promote relaxation.',
      },
      {
      id: 18,
      name: 'Guided Meditation for Self-Love',
      type: 'meditation',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=zzNmOEJUg-s',
      description: 'A meditation practice that focuses on cultivating self-love and acceptance, reducing symptoms of depression and anxiety.',
      },
      {
      id: 19,
      name: 'Visualization for Anxiety',
      type: 'meditation',
      category: 'anxiety',
      link: 'https://www.youtube.com/watch?v=Shaiz2qtR_M',
      description: 'A visualization practice that can help reduce anxiety and promote relaxation.',
      },
      {
      id: 20,
      name: 'Gratitude Visit',
      type: 'mindfulness',
      category: 'depression',
      link: 'https://www.youtube.com/watch?v=oHv6vTKD6lg',
      description: 'Express gratitude to someone who has had a positive impact on your life to reduce symptoms of depression and promote positive emotions.',
      },
      {
      id: 21,
      name: 'Tai Chi',
      type: 'exercise',
      category: 'stress',
      link: 'https://www.youtube.com/watch?v=cEOS2zoyQw4',
description: 'A gentle form of exercise that involves slow and controlled movements, which can reduce stress and promote relaxation.',
},
{
id: 22,
name: 'Yoga for Anxiety',
type: 'exercise',
category: 'anxiety',
link: 'https://www.youtube.com/watch?v=hJbRpHZr_d0',
description: 'A yoga practice that can help reduce anxiety and promote relaxation.',
},
{
id: 23,
name: 'Positive Affirmations',
type: 'mindfulness',
category: 'depression',
link: 'https://www.youtube.com/watch?v=yo1pJ_D-H3M',
description: 'Repeat positive affirmations to yourself to shift negative thought patterns and reduce symptoms of depression.',
},
{
id: 24,
name: 'Progressive Muscle Relaxation',
type: 'relaxation',
category: 'stress',
link: 'https://www.youtube.com/watch?v=SNqYG95j_UQ',
description: 'A relaxation technique that involves tensing and relaxing different muscle groups to promote relaxation and reduce stress.',
},
{
id: 25,
name: 'Coloring',
type: 'art therapy',
category: 'anxiety',
link: 'https://www.youtube.com/watch?v=BN2rTaFUlxs',
description: 'A creative outlet that can help reduce anxiety and promote relaxation.',
},
{
id: 26,
name: 'Nature Sounds',
type: 'sound therapy',
category: 'insomnia',
link: 'https://www.youtube.com/watch?v=Jll0yqdQclw',
description: 'Listening to natural sounds, such as waves or birdsong, can promote relaxation and improve sleep.',
},
{
id: 27,
name: 'Guided Imagery',
type: 'meditation',
category: 'stress',
link: 'https://www.youtube.com/watch?v=t1rRo6cgM_E',
description: 'A visualization practice that can help reduce stress and promote relaxation.',
},
{
id: 28,
name: 'Self-Compassion Break',
type: 'mindfulness',
category: 'anxiety',
link: 'https://www.youtube.com/watch?v=T_80y_CT32c',
description: 'Take a self-compassion break to reduce anxiety and promote self-acceptance and kindness.',
},
{
id: 29,
name: 'Body Scan Meditation',
type: 'meditation',
category: 'stress',
link: 'https://www.youtube.com/watch?v=6IATiVQ1u58',
description: 'A meditation practice that involves bringing awareness to different parts of the body to promote relaxation and reduce stress.',
},
{
id: 30,
name: 'Focus on Wellness',
type: 'wellness',
category: 'stress',
link: 'https://www.youtube.com/watch?v=rKQLBiylsn8',
description: 'A short video that explains us that how important role wellness plays in our life'
},
{
id: 31,
name: 'Ways to Wellness',
type: 'wellness',
category: 'anxiety',
link: 'https://www.youtube.com/watch?v=4ju2G3KtKNA',
description: 'Taking care of your health means taking care of your mind too. AHS shares some simple steps you can take to help you improve both your physical and mental health. ',
},
{
id: 32,
name: 'Wellness: Break the Cycle',
type: 'wellness',
category: 'stress',
link: 'https://www.youtube.com/watch?v=6VSFpMcjbP4',
description: "Tyla's vision for herself is to help save the world from obesity by teaching others about self-worth, health, love and happiness.",
},
// {
// id: 30,
// name: 'Humor',
// type: 'therapy',
// category: 'depression',
// link: 'https://www.helpguide.org/articles/mental-health/benefits-of-humor-and-laughter.htm',
// description: 'Laughing and finding humor in everyday situations can improve mood and reduce symptoms of depression.'
// },



];

data.forEach(item => {
  const videoId = item.link.split('=')[1];
  const thumbnail = youtubeThumbnail(videoId);
  item.image = thumbnail.high.url;
});